import { useContext } from 'react';

import StoreErrorFlagContext from './StoreErrorFlagContext';
import { type ShowStoreErrorFlag } from './StoreErrorFlagId';

export const useOptionalShowStoreErrorFlag = (): ShowStoreErrorFlag | undefined =>
	useContext(StoreErrorFlagContext);
